/* @flow weak */
import React from 'react';
import enumerate from 'lib/enumerate';
import CurrentUser from 'auth/CurrentUser';
import AuthActions from 'auth/AuthActions';
import UserActions from 'user/UserActions';
import OrganizationProfile from 'entities/OrganizationProfile';
import JoinPageLoadingIndicator from './JoinPageLoadingIndicator.jsx';
import JoinOrganizationAvatarPanel from './JoinOrganizationAvatarPanel.jsx';
import ResponsiveMixin from 'components/mixins/ResponsiveMixin';
import DialogContent from 'components/DialogContent.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';

import './styles/ConfirmOrganizationPage.scss';

const STATUS = enumerate([
  'loading',
  'success',
]);

const ConfirmOrganizationPage = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    ResponsiveMixin,
  ],

  statics: {
    SMALL: 700,
    onEnter(nextState, replaceWith, callback) {
      if (CurrentUser.isSignedIn()) {
        callback();
      }

      const onError = () => {
        replaceWith(`/school/join/${nextState.params.id}`);
        callback();
      };

      AuthActions.checkLoggedIn().then(() => callback(), onError);
    },
  },

  getInitialState() {
    return {
      status: STATUS.loading,
      targetOrganization: null,
      currentOrganizations: [],
    };
  },

  componentDidMount() {
    const organizationId = this.props.params.id;
    const orgPromise = OrganizationProfile.fetch({ id: organizationId });

    const organizationIds = CurrentUser.getUser().getOrganizationIds();

    const organizationEntitiesPromise = organizationIds.map(id => {
      return OrganizationProfile.fetch({ id });
    });

    const arrayOfPromises = [orgPromise].concat(organizationEntitiesPromise);

    Promise.all(arrayOfPromises).then(([targetOrganization, ...currentOrganizations]) => {
      this.setState({
        targetOrganization,
        currentOrganizations,
        status: STATUS.success,
      });
    });
  },

  confirmTargetOrganization() {
    const organizationIds = CurrentUser.getUser().getOrganizationIds();
    organizationIds.push(this.state.targetOrganization.id);
    const updateData = { organization_ids: organizationIds };

    UserActions
      .update(updateData)
      .then(this.continueToRemind);
  },

  continueToRemind() {
    this.context.router.push('/landing');
  },

  logout() {
    AuthActions.signOut(`/school/join/${this.props.params.id}`);
  },

  renderAlreadyMember() {
    return (
      <DialogContent
        size="small"
        full>
        <BoxBody>
          <JoinOrganizationAvatarPanel
            title={'You are currently linked to'}
            organization={this.state.targetOrganization}
          />

          <Button
            full
            onClick={this.continueToRemind}
            className="ConfirmOrganizationPage-Submit"
            eventElementName="ConfirmOrganizationPage-Submit">
            Continue to Remind
          </Button>

          {this.renderLogoutOption()}
        </BoxBody>
      </DialogContent>
    );
  },

  renderConfirmation() {
    return (
      <DialogContent
        size="small"
        full>
        <BoxBody>
          <JoinOrganizationAvatarPanel
            title={'Link to'}
            organization={this.state.targetOrganization}
          />

          <Button
            full
            onClick={this.confirmTargetOrganization}
            className="ConfirmOrganizationPage-Submit"
            eventElementName="ConfirmOrganizationPage-Submit">
            Link to {this.state.targetOrganization.getName()}
          </Button>

          {this.renderLogoutOption()}
        </BoxBody>
      </DialogContent>
    );
  },

  renderLoading() {
    return (
      <JoinPageLoadingIndicator />
    );
  },

  renderLogoutOption() {
    return (
      <p className="ConfirmOrganizationPage-Footer">
        Logged in as {CurrentUser.getUser().getSignature()}<br />
        Not you? <Link onClick={this.logout}>Log out</Link>
      </p>
    );
  },

  renderSuccess() {
    const isMemberOfTarget = (
      this.state.currentOrganizations.map(organization => {
        return organization.id;
      }).includes(this.state.targetOrganization.id)
    );

    return isMemberOfTarget ?
      this.renderAlreadyMember() : this.renderConfirmation();
  },

  render() {
    return {
      [STATUS.loading]: this.renderLoading,
      [STATUS.success]: this.renderSuccess,
    }[this.state.status]();
  },
});

export default ConfirmOrganizationPage;



// WEBPACK FOOTER //
// ./src/join/components/ConfirmOrganizationPage.jsx